import { unreachable } from '../../../ts-utils';
export const DELETE = 0;
export const SET = 1;
export const UPDATE = 2;
export const applyPatch = (a, patch) => {
    // @ts-expect-error
    const result = Object.assign({}, a);
    for (const key in patch) {
        const leaf = patch[key];
        switch (leaf.t) {
            case SET: {
                // @ts-expect-error
                result[key] = leaf.v;
                break;
            }
            case DELETE: {
                // @ts-expect-error
                delete result[key];
                break;
            }
            case UPDATE: {
                // @ts-expect-error
                result[key] = applyPatch(a[key], leaf.v);
                break;
            }
            default:
                throw unreachable(leaf);
        }
    }
    return result;
};
//# sourceMappingURL=apply-patch.js.map